import { createItemsData } from '../utils/request.utils'
import { Service } from './base-service'
import { HALApiService } from './hal-api.service'

export const devLogService = new Service('/developer-logs', HALApiService, createItemsData)
